import React from 'react';

const TalpoolLogo = (props) => (
    <svg
        version="1.1"
        fill="white"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px" y="0px"
        width="100%"
        height="110px"
        viewBox="0 187.089 841.889 221.102"
        xmlSpace="preserve"
        {...props} // allows passing className, style, etc.
    >
        <g>
            <path d="M81.981,327.628c-4.355,2.155-9.46,3.433-13.596,3.433c-9.328,0-14.695-5.896-14.695-16.147v-50.16h32.604v-26.048h-32.34
		v-33.354l-30.097,3.212v30.184H1.945v26.048h21.912v50.16c0,14.521,3.96,25.695,11.836,33.265
		c6.908,6.645,16.721,10.121,28.558,10.121c0.747,0,1.54,0,2.287-0.045c8.8-0.221,15.796-1.673,24.023-4.974l0.615-0.264
		l-8.403-25.784L81.981,327.628z"></path>
            <path d="M187.889,253.487c-6.996-10.736-21.604-17.864-36.916-17.864h-0.572c-17.775,0-33.527,5.896-44.308,16.588
		c-11,10.912-16.808,26.576-16.808,45.32c0,19.535,5.852,35.686,16.984,46.686c10.647,10.56,25.651,16.146,43.428,16.146h0.572
		c13.641-0.264,30.624-6.996,37.708-19.403l1.32,15.84h28.38v-118.36h-28.865L187.889,253.487z M187.318,297.663
		c0,9.196-2.991,17.776-8.447,24.112c-6.116,7.172-14.872,10.912-25.301,10.912c-9.46,0-18.084-3.301-24.244-9.328
		c-6.513-6.38-9.988-15.312-9.988-25.872c0-10.516,3.433-19.404,9.988-25.74c6.115-5.939,14.739-9.195,24.244-9.195
		c10.429,0,19.185,3.783,25.301,10.911C184.325,279.886,187.318,288.467,187.318,297.663z"></path>
            <rect x="232.461" y="189.467" width="29.832" height="167.378"></rect>
            <polygon points="381.489,241.079 381.665,240.859 381.665,238.483 346.157,238.483 307.438,284.683 307.438,189.467 
		277.341,189.467 277.341,356.844 307.438,356.844 307.438,304.659 352.581,356.844 388.309,356.844 388.309,353.983 
		334.013,294.187 	"></polygon>
            <path d="M736.041,236.107c-21.956,0-40.262,9.548-51.129,26.355c-7.566-18.172-20.899-33.836-38.323-44.22l-0.616-0.352
		l-8.932,15.486l0.615,0.354c22.483,13.464,36.476,37.972,36.476,63.976c0,26.05-13.991,50.601-36.563,64.021l-0.616,0.354
		l8.934,15.486l0.614-0.351c17.381-10.296,30.714-25.916,38.325-44c0.044,0.044,0.044,0.087,0.087,0.131
		c10.913,16.809,29.174,26.093,51.394,26.093c18.348,0,33.968-6.248,45.231-18.084c10.604-11.133,16.456-26.62,16.456-43.604
		c0-16.808-5.983-32.252-16.809-43.516C769.699,242.399,754.08,236.107,736.041,236.107z M767.633,297.795
		c0,9.108-2.815,17.513-7.876,23.629c-5.634,6.775-13.772,10.384-23.496,10.384s-17.819-3.563-23.496-10.384
		c-5.104-6.116-7.875-14.477-7.875-23.629c0-9.02,2.815-17.424,7.964-23.628c5.72-6.907,13.816-10.56,23.408-10.56
		C755.885,263.563,767.633,280.943,767.633,297.795z"></path>
            <rect x="808.025" y="189.467" width="29.833" height="167.378"></rect>
            <path d="M636.601,297.751c0-20.416-16.632-37.048-37.048-37.048c-20.415,0-37.048,16.632-37.048,37.048
		c0,20.415,16.633,37.049,37.048,37.049C619.969,334.8,636.601,318.168,636.601,297.751z"></path>
            <path d="M524.973,297.751c0-26.004,13.992-50.512,36.476-63.976l0.617-0.354l-8.933-15.487l-0.615,0.352
		c-17.688,10.517-31.153,26.532-38.677,45.012c-10.736-17.512-29.216-27.456-51.349-27.456c-11.924,0-27.939,4.753-37.708,17.908
		l-1.804-15.312h-28.114v167.376h30.095v-61.644c5.808,7.743,18.655,15.53,38.5,15.53c21.69,0,39.424-9.106,49.896-25.651
		c0.044-0.044,0.31-0.484,0.748-1.188c7.567,18.26,20.944,34.012,38.456,44.396l0.616,0.352l8.932-15.488l-0.616-0.352
		C539.009,348.351,524.973,323.8,524.973,297.751z M493.116,297.795c0,18.7-14.08,32.78-32.779,32.78s-32.779-14.08-32.779-32.78
		c0-19.315,13.464-32.779,32.779-32.779C479.653,264.971,493.116,278.479,493.116,297.795z"></path>
            <path d="M552.824,297.751c0-16.412,8.447-31.328,22.527-39.907l0.616-0.353l-8.933-15.488l-0.615,0.396
		c-19.713,11.836-31.505,32.56-31.505,55.396c0,22.528,12.101,43.78,31.593,55.44l0.615,0.353l8.933-15.487l-0.616-0.354
		C561.273,329.123,552.824,314.207,552.824,297.751z"></path>
            <path d="M664.189,297.751c0-22.836-11.791-43.56-31.504-55.396l-0.615-0.396l-8.933,15.488l0.615,0.352
		c14.125,8.58,22.527,23.496,22.527,39.908c0,16.456-8.447,31.372-22.616,39.952l-0.614,0.354l8.932,15.487l0.616-0.354
		C652.089,341.531,664.189,320.279,664.189,297.751z"></path>
        </g>
    </svg>
);

export default TalpoolLogo;